import { Button, ButtonProps } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../hooks/dialog/useDialogContext';
import styles from './ShareCertificateButton.module.css';

type ShareCertificateButtonProps = {
  certificateType: string;
  certificateId: string;
} & ButtonProps;

const ShareCertificateButton = ({
  certificateType,
  certificateId,
  ...restProps
}: ShareCertificateButtonProps): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  const onClick = () => {
    openDialog('share-certificate-dialog', { certificateType, certificateId });
  };

  return (
    <div className={classNames('w-full md:w-auto flex', styles['share-certificate-button'])}>
      <Button
        onClick={onClick}
        label={t('certificateDetailsPage.buttons.shareCertificate')}
        icon='pi pi-arrow-right'
        iconPos='right'
        type='button'
        className='w-full md:w-auto md:min-w-max'
        {...restProps}
      />
    </div>
  );
};

export default ShareCertificateButton;
